import "./index.scss";
const NoDisplay = () => {
    //Landscape orientation and 850*590 minimum resolution required to display.
    return(
        <div className="no-display"> 
            Landscape orientation and 1024*640 minimum resolution required to display.
        </div>
    )
}

export default NoDisplay;